import React, { Children, useEffect, useState } from 'react';

const PAGE_SIZE = 5;

const SellerOrderPagination = ({ children }) => {
  const [page, setPage] = useState(1);
  const orders = Children.toArray(children);
  const pageCount = Math.max(1, Math.ceil(orders.length / PAGE_SIZE));
  const orderSignature = orders.map((order) => order.key || '').join('|');

  useEffect(() => {
    setPage(1);
  }, [orderSignature]);

  useEffect(() => {
    setPage((currentPage) => Math.min(currentPage, pageCount));
  }, [pageCount]);

  const startIndex = (page - 1) * PAGE_SIZE;
  const visibleOrders = orders.slice(startIndex, startIndex + PAGE_SIZE);

  if (orders.length <= PAGE_SIZE) {
    return <div className="space-y-4">{visibleOrders}</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-col items-center justify-between gap-3 rounded-2xl border border-gray-100 bg-white px-5 py-4 sm:flex-row">
        <p className="text-xs font-bold text-slate-500">
          Showing {startIndex + 1}–{Math.min(startIndex + PAGE_SIZE, orders.length)} of {orders.length} orders
        </p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setPage((currentPage) => Math.max(1, currentPage - 1))}
            disabled={page === 1}
            aria-label="Show previous orders"
            className="rounded-xl border border-gray-200 px-4 py-2 text-xs font-black text-slate-600 transition hover:border-indigo-200 hover:text-indigo-600 disabled:cursor-not-allowed disabled:opacity-40"
          >
            Previous
          </button>
          <span className="min-w-20 text-center text-xs font-black text-slate-500">
            Page {page} of {pageCount}
          </span>
          <button
            type="button"
            onClick={() => setPage((currentPage) => Math.min(pageCount, currentPage + 1))}
            disabled={page === pageCount}
            aria-label="Show next orders"
            className="rounded-xl border border-gray-200 px-4 py-2 text-xs font-black text-slate-600 transition hover:border-indigo-200 hover:text-indigo-600 disabled:cursor-not-allowed disabled:opacity-40"
          >
            Next
          </button>
        </div>
      </div>
      {visibleOrders}
    </div>
  );
};

export default SellerOrderPagination;
